import { render } from "./TopLogo.vue?vue&type=template&id=4fe7520b"
import script from "./TopLogo.vue?vue&type=script&lang=ts"
export * from "./TopLogo.vue?vue&type=script&lang=ts"
script.render = render

export default script